import React from 'react'
import { Redirect } from 'react-router-dom'

import { Routes } from '../../navigation/config/routes'

export const PhoneRedirect: React.FC = () => (
    <Redirect to={Routes.manage.voiceAgent.root} />
)
